import React from "react";
import UiTag from "../ui/UiTag";


const MedicineStockTag = ({ medicine, style }) => {
  if (!medicine?.is_pharmacy_medicine) return null;
  if (medicine.current_stock === null || medicine.current_stock === undefined) {
    return null;
  }

  const inStock = Number(medicine.current_stock) > 0;
  return (
    <UiTag
      tone={inStock ? "success" : "danger"}
      size="sm"
      style={{ marginInlineEnd: 0, ...style }}
    >
      {inStock ? "Available" : "Out of Stock"}
    </UiTag>
  );
};


export const MedicineOptionRow = ({ label, medicine }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      width: "100%",
    }}
  >
    <span style={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" }}>
      {label}
    </span>
    <MedicineStockTag medicine={medicine} />
  </div>
);

export default MedicineStockTag;
